// type ArtConfig =
//   | {
//       href: string;
//       showPrice?: "above" | "below";
//       text?: string | JSX.Element;
//       onMouseEnter?: () => void;
//       onMouseLeave?: () => void;
//       actionBelow?: {
//         actionComponent: JSX.Element;
//       };
//       actionCorner?: CornerActionType;
//       tileClassName?: string;
//       height?: number;
//       hoverHeight?: number;
//     }

import { ListItem } from "../../../../types";
import { ORDER_STATUSES, OrderData } from "../../../../types/order";
import { OrderDetails } from "./OrderDetails";

//   | undefined;
export const OrderItem = ({
  item, // artConfig,
  style = "flexible",
}: {
  style: "flexible" | "row";
  item: ListItem<
    OrderData,
    {
      href: string;
      isAdmin: boolean;
    }
  >;
}) => {
  // const height = artConfig?.height ?? 250;
  // const hoverHeight = artConfig?.hoverHeight ?? artConfig?.height ?? 350;
  // height is set and no hover height, just don't hover. other wise, use default hover
  return (
    <div className={"flex-[1_1_auto] lg:flex-[0.5_1_auto] duration-300"}>
      <div
        className={
          (item.orderStatus == ORDER_STATUSES.PLACED.key ||
          item.orderStatus == ORDER_STATUSES.IN_PROGRESS.key
            ? "bg-warning text-primary border-solid border-2 border-textWarning "
            : "bg-secondary text-textSecondary border-solid border-2 border-textPrimary ") +
          " rounded-2xl shadow-md hover:shadow-lg" +
          " pt-7 px-4 pb-4 duration-300 "
        }
      >
        <a
          href={item.__meta.href}
          className={
            style === "flexible"
              ? "flex-1 items-center rounded-xl decoration-none  cursor-pointer flex justify-between flex flex-col"
              : ""
          }
        >
          <OrderDetails
            order={{ ...item }}
            admin={item.__meta.isAdmin}
            shipmentsRequest={undefined}
            showCreateShipmentBtn={false}
            showViewShipmentBtn={true}
            showItems={true}
            // showShipmentItems={false}
            showViewOrderBtn={false}
          />
        </a>
      </div>
    </div>
  );
};
